import React, { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import Createcarpetid from "../../assets/images/sidebar-icons/Createcarpetid.svg";
import managment from "../../assets/images/sidebar-icons/managment.svg";
import certificate from "../../assets/images/sidebar-icons/certificate.svg";
import carpet from "../../assets/images/sidebar-icons/carpet.svg";
import category from "../../assets/images/sidebar-icons/category.svg";

const Sidebar = () => {
  const hamburgerMenuIcon = useRef();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const closeHamburgerMnu = (e) => {
    e.preventDefault();
    hamburgerMenuIcon.current.checked = false;
    setShowHamburgerMenu(false);
  };

  return (
    <>
      <div className="hamburger-menu-container">
        <input
          className="checkbox"
          type="checkbox"
          ref={hamburgerMenuIcon}
          onChange={() => setShowHamburgerMenu(!showHamburgerMenu)}
        />
        <div className="hamburger-lines">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </div>
      </div>

      <div className={`sidebar ${showHamburgerMenu ? "show-sidebar" : ""}`}>
        {/* <div className={`sidebar ${sidebarPin || sidebarExpand ? `pin-sidebar` : ''}`}
         onMouseEnter={() => setSidebarExpand(true)}
         onMouseLeave={() => setSidebarExpand(false)}
         > */}
        {/* <div className="pin-container">
                <img
                    src={sidebarPin ? emptyPin : fullPin}
                    onClick={() => setSidebarPin(!sidebarPin)}
                    alt="icon"
                />
            </div> */}
        <div className="list-items-container">
          <ul className="list-items">
            <li className="list-item">
              <img src={managment} alt="" srcSet="" />
              <span className="list-item-text">مدیریت فرش</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              {/* <NavLink to="/signup-passenger"
                                className={({ isActive }) => isActive ? "link active-link" : "link"}

                            > */}
              <NavLink
                to="/Carpet/Managment-Carpet"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={carpet}
                  alt="icon"
                />
                <span className="list-item-text">مدیریت فرش </span>
              </NavLink>
            </li>
            {/* <li className="list-item">
                            <NavLink to="/"
                                className={({ isActive }) => isActive ? "link active-link" : "link"}
                            >
                                <img className='list-item-icon' src={addPassenger} alt="icon" />
                                <span className='list-item-text' >
                                    لیست تمام مسافران
                                </span>
                            </NavLink>
                        </li> */}
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/Certificate/Show-Certificate"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={certificate}
                  alt="icon"
                />
                <span className="list-item-text">مدیریت شناسنامه</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/Carpet/Create-Category"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={category}
                  alt="icon"
                />
                <span className="list-item-text">مدیریت دسته بندی فرش</span>
              </NavLink>
            </li>
            {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-commodity-and-services"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Goodsandservices}
                  alt="icon"
                />
                <span className="list-item-text">تعریف کالا و خدمات</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-warehouse"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehouse} alt="icon" />
                <span className="list-item-text">تعریف انبار</span>
              </NavLink>
            </li>
          </ul>
          <ul className="list-items">
            <li className="list-item">
              <img src={Warehousedocuments} alt="" srcSet="" />
              <span className="list-item-text">اسناد انبار </span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-entry-document"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={WarehouseEntryDocument}
                  alt="icon"
                />
                <span className="list-item-text">سند ورود انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-exit-document"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Warehouseexitdocument}
                  alt="icon"
                />
                <span className="list-item-text">سند خروج انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-opening-documents"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={opening} alt="icon" />
                <span className="list-item-text">اسناد افتتاحیه انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-closing-documents"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={closing} alt="icon" />
                <span className="list-item-text">اسناد اختتامیه انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-handling"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Warehousehandling}
                  alt="icon"
                />
                <span className="list-item-text">انبار گردانی </span>
              </NavLink>
            </li>
          </ul>
          <ul className="list-items">
            <li className="list-item">
              <img src={hesabdari} alt="" srcSet="" />
              <span className="list-item-text">حسابداری</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/2"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehousenewdocuments} alt="icon" />
                <span className="list-item-text">ثبت سند جدید</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/1"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehousealldocuments} alt="icon" />
                <span className="list-item-text">مشاهده تمام اسناد</span>
              </NavLink>
            </li>
          </ul>
          <ul className="list-items">
            <li className="list-item">
              <img src={setting} alt="" srcSet="" />
              <span className="list-item-text">تنظیمات</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/persons"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={person} alt="icon" />

                <span className="list-item-text">اشخاص</span>
              </NavLink>
            </li>

            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/9"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Collectionprofile}
                  alt="icon"
                />
                <span className="list-item-text">پروفایل مجموعه</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/5"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Administrativesettings}
                  alt="icon"
                />
                <span className="list-item-text">تنظیمات مدیریتی</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-warehouse-entry-document-antd"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={hesabdari} alt="icon" />
                <span className="list-item-text">antd </span>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
